"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const address_1 = require("./models/address");
exports.feeErgoTree = '1005040004000e36100204a00b08cd0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798ea02d192a39a8cc7a701730073011001020402d19683030193a38cc7b2a57300000193c2b2a57301007473027303830108cdeeac93b1a57304';
exports.feeMainnetAddress = new address_1.Address('2iHkR7CWvD1R4j1yZg5bkeDRQavjAaVPeTDFGGLZduHyfWMuYpmhHocX8GJoaieTx78FntzJbCBVL6rf96ocJoZdmWBL2fci7NqWgAirppPQmZ7fN9V6z13Ay6brPriBKYqLp1bT2Fk4FkFLCfdPpe');
exports.feeTestnetAddress = new address_1.Address('Bf1X9JgQTUtgntaer91B24n6kP8L2kqEiQqNf1z97BKo9UbnW3WRP9VXu8BXd1LsYCiYbHJEdWKxkF5YNx5n7m31wsDjbEuB3B13ZMDVBWkepGmWfGa71otpFViHDCuvbw1uNicAQnfuWfnj8fbCa4');
exports.feeValue = 1000000;
exports.minBoxValue = 100000;
exports.unitsInOneErgo = 1000000000;
exports.heightDelta = 720;
//# sourceMappingURL=constants.js.map